var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomePurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1527 1.06425L13.7353 2.72727L16.3824 4.36364L17.3343 5.09926C18.0695 5.66736 18.5 6.54402 18.5 7.47312V14.5C18.5 16.433 16.933 18 15 18H4C2.067 18 0.5 16.433 0.5 14.5V7.60555C0.5 6.60249 1.0013 5.6658 1.8359 5.1094L7.86441 1.09039C8.85769 0.428209 10.149 0.417944 11.1527 1.06425Z",
    fill: "#6C59DB"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.35297,
    y1: 14.3235,
    x2: 11.6471,
    y2: 14.3235,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePurple);
export default __webpack_public_path__ + "static/media/homePurple.5b4911fbfea9cfabc46d996e0b77076d.svg";
export { ForwardRef as ReactComponent };